export interface IAccountService {
  /** Get the endpoints to access the account APIs. */
  getAccountEndpoints: () => Promise<any>;
  /** Get the villages that the signed-in user has access to. */
  getVillages: () => Promise<any>;
  /** Get the permissions that are associated to the signed-in user's roles. */
  getPermissions: () => Promise<any>;
  /** Authenticate the user. */
  authenticate: () => Promise<any>;
}

export class AccountService implements IAccountService {
  private readonly _accountEndpointUrlPrefix = "/RymanIdentity/account";
  private readonly _getAccountEndpointsUrl = `${this._accountEndpointUrlPrefix}/.well-known/endpoints`;
  private readonly _userClaimsUrl = `${this._accountEndpointUrlPrefix}/me`;
  private readonly _villagesUrl = `${this._userClaimsUrl}/villages`;
  private readonly _permissionsUrl = `${this._userClaimsUrl}/permissions`;

  getAccountEndpoints = async () => {
    return await fetch(this._getAccountEndpointsUrl);
  };

  getVillages = async () => {
    return await fetch(this._villagesUrl, {
      credentials: "include"
    });
  };

  getPermissions = async () => {
    return fetch(this._permissionsUrl, {
      credentials: "include"
    });
  };

  authenticate = async () => {
    return await fetch(this._userClaimsUrl, {
      mode: "cors",
      credentials: "include"
    });
  };
}
